import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
	CButton,
	CModal,
	CModalBody,
	CModalFooter,
	CModalHeader,
	CModalTitle,
	CForm,
	CInputGroup,
	CFormInput,
	CListGroup,
	CListGroupItem,
	CRow,
	CCol,
	CSpinner,
} from '@coreui/react';
import CIcon from '@coreui/icons-react';
import PropTypes from 'prop-types';
import { UFunc } from "../helpers/functions";
import { isMobile } from "react-device-detect";

const pjson     		= require('../../package.json');
const MyDialoglookupapi = props => {
	const {
		show, toggle, dialogHeader, inputValue,
		targetApi, kdownTrigger, onKlikPilihItem,
		setLoading, prosesExpired, setSessionaktif,
		...rest
	} = props;

	const uDispatch			= useDispatch();
	const uBahasaob  		= useSelector(state => state.listBahasa);
	const uTokenObj			= JSON.parse(localStorage.getItem("token"));
	const uDataselectedObj	= useSelector(state => state.lookupapiobj) || {};

	const [uInputValue,setInputValue]	= React.useState(inputValue || "xx");
	const [uCursorPos,setCursorPos]		= React.useState(-1);
	const [uMsgerror500,setMsgerror500]	= React.useState();
	const [uDataSearchArr,setDataSearchArr]	= React.useState([]);
	const [uISProcessing,setProcessing]	= React.useState(false);
	const [uViewfirst,setViewfirst]		= React.useState(false);

	const hdlKeyDownModal = (_EV) => {
		if (_EV.keyCode === 38 && uCursorPos >= 0) {//--->UP
			_EV.preventDefault();
			setCursorPos(uCursorPos-1);
			return;
		} else if (_EV.keyCode === 40 && uCursorPos < uDataSearchArr.length-1) {//--->DOWN
			_EV.preventDefault();
			setCursorPos(uCursorPos+1);
			return;
		}

		if(_EV.keyCode === 13) {
			if(uCursorPos < 0 || uCursorPos >= uDataSearchArr.length) return;

			_EV.preventDefault();
			const vIdx = uCursorPos;
			hdlKlikPilihitem(uDataSearchArr[vIdx].id);
			return;
		}//-*/
	}
	const hdlKeyDownInput = (_EV) => {
		if(_EV.keyCode===13) {
			_EV.preventDefault();
			_EV.stopPropagation();
			//setCursorPos(0);
			const vElfocus = document.getElementById("btnlookupsearch");
			vElfocus && (vElfocus.click());
			return;
		}//-*/
	}
	const hdlKlikCari = () => {//--TIDAK_DIPAKAI--/
		let vElfocus = document.getElementById("inpdialoglookup")
		if((uInputValue||"").trim() === "") {
			if(!isMobile) vElfocus && vElfocus.focus();
			setMsgerror500("<b>Pencarian Harus Lebih Spesifik</b>.."+
				"<br/>Mohon Gunakan Keyword Dengan Jumlah Karakter yang Tepat !"+
				"");
			return;
		}

		apiLoaddata();
	}
	const hdlKlikPilihitem = (_IDTABEL) =>{
		_IDTABEL = parseInt(_IDTABEL)||0;
		const vArridx = UFunc.getObjectIndeks(uDataSearchArr,_IDTABEL) ;
		onKlikPilihItem(JSON.stringify(uDataSearchArr[vArridx]));
	}

	const apiLoaddata = (_KEYWORD) => {
		_KEYWORD 	= (_KEYWORD||"").trim();

		setMsgerror500();
		setDataSearchArr([])
		setProcessing(true);

		/*//--TESTING_FRONTEND--/
		console.log("(MyDialoglookupapi-apiLoaddata) LEWAT ");
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			setProcessing(false);
			setDataSearchArr(vTmpArr)
		},2000); return
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_keyword: uInputValue||"",
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= (targetApi||"");
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) { setSessionaktif(false); return response.json();} })
		.then((output_string) => {
			setSessionaktif(true);
			setProcessing(false);
			//console.log("(MyDialoglookupapi - apiLoaddata) output_string : "+output_string);
			if(output_string.tampil) {
				const vTmpArr = (JSON.parse(output_string.dataobject||"[]"));
				if(vTmpArr.length <= 0) {
					setMsgerror500(
						"<b>Maaf</b>,"+
						"<br/>Data Pencarian Tidak Ditemukan, Silahkan Gunakan Keyword yang Lain.."+
						"");
					return;
				}

				setDataSearchArr(vTmpArr);
			} else if(output_string.info) {
				setMsgerror500(output_string.info);
			} else if(output_string.errors) {
				console.log("(MyDialoglookupapi - apiLoaddata) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				setMsgerror500(vMsg);
			} else if(output_string.expired) {
				setLoading(true);prosesExpired();
			}
		})
		.catch((error) =>{
			setProcessing(false);
			console.log("(MyDialoglookupapi - apiLoaddata) catch-error: "+error);
			setMsgerror500(pjson.mydefault.msg500str.join(" "));
		});
	}

	const debouncedSearch = React.useCallback((value) => {
		// Clear previous timeout if exists
		// This ensures that if user types quickly, previous API calls are cancelled
		// and only the latest one is made after the debounce time.
		const handler = setTimeout(() => {
			if (value) {
				apiLoaddata(value);
			} else {
				// If search term is empty, clear results and loading state
				setDataSearchArr([]);
				setLoading(false);
				setProcessing(false);
			}
		}, 650); // 500ms debounce time

		return () => {
			clearTimeout(handler); // Cleanup function to clear timeout on unmount or re-render
		};
	},[apiLoaddata]);

	React.useEffect(()=>{
		return () => { 
			setDataSearchArr([]);
			setInputValue(""); setCursorPos(-1); 
			setViewfirst(false); 
			toggle();
		}
	},[]);
	React.useEffect(()=>{
		if(!show) { 
			setDataSearchArr([]);
			setInputValue(""); setCursorPos(-1); 
			setViewfirst(false); 
			return;
		}//-*/
		
		setInputValue(inputValue || "");
		if((inputValue || "").trim() === "") setViewfirst(true);//-*/

		//console.log("[show] inputValue = ",(new Date()).toString());
		let vTimeout = setTimeout(function(e){
			clearTimeout(vTimeout);
			const vElsinput	= document.getElementById("inpdialoglookup");
			const vElsrow	= document.getElementById("idrowscroll");

			//console.log("[show] Checked..");
			vElsinput && vElsinput.scrollTo(0,0);
			if(inputValue === "") {
				if(!isMobile) vElsinput && vElsinput.focus();
			} else
				vElsinput && vElsinput.select();
		},350);//-*/
	},[show]);
	React.useEffect(()=>{
		if(!show) return;
		
		const cleanup = debouncedSearch(uInputValue);
		return cleanup;
	},[uInputValue]);
	React.useEffect(()=>{
		if(!uViewfirst) return;

		apiLoaddata();
	},[uViewfirst]);//-*/
	React.useEffect(()=>{
		if(uDataSearchArr.length <= 0) {
			return;
		}

		console.log("(MyDialoglookupapi - [uDataSearchArr]) uDataSearchArr.length : "+uDataSearchArr.length);
		console.log("(MyDialoglookupapi - [uDataSearchArr]) kdownTrigger",kdownTrigger);
		if((kdownTrigger||false)===true) {
			if(uDataSearchArr.length === 1) {
				hdlKlikPilihitem(uDataSearchArr[0].id);
				return;
			}
		}
	},[uDataSearchArr,uDataSearchArr.length]);
    React.useEffect(() => {
		const vElsinput	= document.getElementById("inpdialoglookup");
		const vElsrow	= document.getElementById("idrowscroll");

		if(uCursorPos <= 0) {
			vElsinput && vElsinput.scrollTo(0,0);
		}
		if(uCursorPos < 0) {
			if(!isMobile) vElsinput && vElsinput.focus();
			return;
		}

		if(!isMobile)
			document.getElementById("idlistitem"+uCursorPos) && 
				document.getElementById("idlistitem"+uCursorPos).focus();
    }, [uCursorPos]);

    //if (!show) return null;

	return (
		<div onKeyDown={(e)=>hdlKeyDownModal(e)}>
		<CModal
			alignment={"top"}
			className="z-2099"
			visible={show} 
			scrollable
			onClose={toggle}>
		<CModalHeader closeButton className="bg-dark text-light py-2">
			<CModalTitle className="">
				<div className="d-none d-md-block">{dialogHeader || MyDialoglookupapi.defaultProps.dialogHeader} <small>(Advanced)</small></div>
				<small className="d-block d-md-none">{dialogHeader || MyDialoglookupapi.defaultProps.dialogHeader} (Advanced)</small>
			</CModalTitle>
		</CModalHeader>

		<CModalBody className="p-0">
			<div className="sticky-top bg-light mx-auto p-3 px-lg-5" id="idheaderlookup">
				<CForm>
				<CInputGroup size="sm">
				<CFormInput size="sm"
					autoFocus={true}
					autoComplete="true"
					value={uInputValue}
					onChange={(e)=>setInputValue(e.target.value)}
					onKeyDown={(e)=>{return false; hdlKeyDownInput(e)}}
					onFocus={(e)=>setCursorPos(-1)}
					readOnly={uISProcessing}
					placeholder="--Masukkan Keyword Pencarian.."
					id="inpdialoglookup"/>
				{(1 == 2) && (
				<CButton size="sm" color="secondary"
					className="text-white"
					onClick={()=>hdlKlikCari()}
					id="btnlookupsearch">
					<CIcon icon="cilMagnifyingGlass" size="sm"/>
				</CButton>
				)}
				</CInputGroup>
				</CForm>
			</div>

			<div className="p-3" id="idrowscroll" style={{minHeight:window.innerHeight-240}}>
			{(uMsgerror500) ? (
			<>
				<div className="classborderbottom mb-3 mb-lg-"/>

				<div className="m-2 pb-lg-3 px-lg-5">
					<span className="classpetunjuk px-0	">{UFunc.renderHTML(uMsgerror500)}</span>
				</div>
			</>
			) : (
			<>
			{uISProcessing ? (
				<div className="py-5 text-primary text-center">
				<CSpinner/>
				<span className="classfontsmaller fst-italic d-block"><small>Mohon Ditunggu</small></span>
				</div>
			) : (
				<CListGroup> 
				{(uDataSearchArr).map((vItems,vKeys)=>{
				//console.log("(MyDialoglookupapi - uDataSearchArr.map) uCursorPos===vKey => "+uCursorPos+"==="+vKey);
				return (
					<CListGroupItem key={vKeys}
						id={"idlistitem"+vKeys}
						tabIndex={vKeys}
						active={uCursorPos===vKeys}
						onClick={()=>hdlKlikPilihitem(vItems.id)}
						className="py-2 list-group-item-action classcursorpointer">
						<CRow>
						<CCol className="px-1 text-capitalize">
							{vItems.caption}
							{vItems.caption_sub && (
							<div className="mx-2 classfontsmaller">
							<small className="fst-italic">{UFunc.renderHTML(vItems.caption_sub)}</small>
							</div>
							)}
						</CCol>

						{vItems.nilai && (
						<CCol xs="3" className="px-1 text-end fw-bolder">
							Rp{UFunc.formatAngka(vItems.nilai)}
						</CCol>
						)}
						</CRow>
					</CListGroupItem>
				)
				})}
				</CListGroup>
			)}
			</>
			)}
			</div>
		</CModalBody>
		
		<CModalFooter className="bg-light">
		<CButton 
			className="px-3 text-white"
			color="secondary" 
			onClick={toggle}
			id="btnDialoglookupOK"> 
		{uBahasaob.word_ok||"Ok !"}
		</CButton>
		</CModalFooter>
		</CModal>
		</div>
	)//>
}
MyDialoglookupapi.defaultProps = {
	show: false,
	dialogHeader: "Lookup Data Item",
	onKlikPilihItem:()=>{},
	targetApi: pjson.homepage+"api/",
	kdownTrigger: false,
};

MyDialoglookupapi.propTypes = {
	show: PropTypes.bool,            
	toggle: PropTypes.func,     
	dialogHeader: PropTypes.string,
	inputValue: PropTypes.string,
	targetApi: PropTypes.string, 
	kdownTrigger: PropTypes.bool,            
	onKlikPilihItem: PropTypes.func,     
}

export default MyDialoglookupapi;
